/**
 * LEVEL TITLE — the word beside your number ("The Adept"), resolved from XP.
 *
 * ⭐ REUSES THE EXISTING LADDER in src/lib/tiers.ts rather than inventing a second one. The six FIXED
 * tiers (Lurker → Strategist) are pure XP milestones and are all that a single account's own XP can
 * determine, so that is what the crest shows. The six COMPETITIVE tiers (Seer → Silent Hand) depend
 * on where you rank against everyone, which only the rankings/profile surfaces can compute — those
 * upgrade the title there via getEffectiveTier(). Keeping both readings off one `tiers` map means the
 * title can never contradict itself.
 */
import { getFixedTierFromRenown, tiers, type TierKey } from '@/lib/tiers'

export interface LevelTitle {
  key: TierKey
  name: string
  /** Tailwind text-color class, e.g. 'text-amber-400'. */
  color: string
  description: string
}

export function levelTitle(xp: number | string | null | undefined): LevelTitle {
  const n = typeof xp === 'number' ? xp : parseFloat(String(xp ?? '0'))
  const renown = Number.isFinite(n) && n > 0 ? n : 0
  const key = getFixedTierFromRenown(renown)
  const t = tiers[key]
  return { key, name: t.name, color: t.color, description: t.description }
}
